import { createFileRoute } from "@tanstack/react-router";
import AdminPartsPageEdit from "@/pages/admin/AdminPartsPageEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/content/new")({
  component: AdminPartsPageEdit,
});
